import { useMutation, useQueryClient } from '@tanstack/react-query';
import { markContactRead } from '../../api/apiContacts';
import toast from 'react-hot-toast';

export const useMarkContactRead = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: markContactRead,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['contacts'] });
            toast.success(data.message || 'Message marked as read');
        },
        onError: (error) => {
            const errorMessage = error.response?.data?.message || 'Failed to mark as read';
            toast.error(errorMessage);
        },
    });
};